import { EASY_NOTIFICATIONS_IDENTIFIER } from "@/src/easy-ui/constants/easyNotifications";
import { bemIfy } from "@/src/shared/utils/classesHelpers";

export const easyNotificationsBem = (e?: string, m?: string) => {
  return bemIfy(EASY_NOTIFICATIONS_IDENTIFIER, e, m);
};
